import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import Header from '../components/Header';

// Only the first ARC sector (octant id 0 → "ARC - 1") is currently accessible.
const UNLOCKED_OCTANT = 0;

function Octants() {
  const navigate = useNavigate();
  const octants = Array.from({ length: 8 }, (_, i) => ({
    id: i,
    name: `ARC - ${i + 1}`
  }));

  return (
    <div className="min-h-screen pb-20">
      <Header breadcrumbs={[{ label: 'ARC Sectors' }]} />

      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h2 className="text-4xl font-bold mb-2">Select an ARC Sector</h2>
          <p className="text-muted-foreground">The universe is divided into 8 ARC sectors. Only <span className="text-primary font-semibold">ARC - 1</span> is currently accessible — the remaining sectors are locked.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="octants-grid">
          {octants.map((octant) => {
            const locked = octant.id !== UNLOCKED_OCTANT;
            if (locked) {
              return (
                <div
                  key={octant.id}
                  className="glass-card rounded-xl p-6 text-left opacity-50 cursor-not-allowed select-none"
                  data-testid={`octant-${octant.id}-locked`}
                  aria-disabled="true"
                  title="This ARC sector is locked"
                >
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-2xl font-bold text-muted-foreground">{octant.name}</h3>
                    <Lock className="w-5 h-5 text-muted-foreground" />
                  </div>
                  <p className="text-sm text-muted-foreground">Locked</p>
                </div>
              );
            }
            return (
              <button
                key={octant.id}
                onClick={() => navigate(`/explore/galaxies/${octant.id}`)}
                className="glass-card rounded-xl p-6 text-left group"
                data-testid={`octant-${octant.id}`}
              >
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-2xl font-bold text-primary">{octant.name}</h3>
                  <svg className="w-6 h-6 text-cyan-400 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
                <p className="text-sm text-muted-foreground">50,000 Galaxies</p>
              </button>
            );
          })}
        </div>

        {/* ARC Logo Video */}
        <div className="mt-12 flex justify-center" data-testid="arc-video-container">
          <div className="glass-card rounded-xl p-4 max-w-2xl w-full">
            <video 
              autoPlay 
              loop 
              muted 
              playsInline
              className="w-full rounded-lg"
              data-testid="arc-logo-video"
            >
              <source 
                src="https://customer-assets.emergentagent.com/job_planet-discovery-1/artifacts/okhnagu3_Arc%20Logo%20V.01%20%281%29%20%281%29%20%281%29%20%282%29.mp4" 
                type="video/mp4" 
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Octants;
